import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { safeRedirectPath } from '@/hooks/use-auth-actions'
import { SignIn } from '@/features/auth/sign-in'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ href: safeRedirectPath(search.redirect) })
    }
  },
  component: SignIn,
  validateSearch: searchSchema,
})
